import { cn } from "@/lib/utils";

const logoDark = "/healnova-logo-dark.png";
const logoWhite = "/healnova-logo-white.png";

/**
 * Official HealNova Healthcare wordmark, matched to the size used on
 * healnova.ai (~40px tall in the header).
 *
 * The portal is light-mode only, so the dark-ink mark is the default
 * everywhere. Pass `onDark` on the maroon plates — the login panel and the
 * marketing footer — to get the white mark instead.
 */
export function Logo({
  className,
  showWordmark = true,
  onDark = false,
}: {
  className?: string | undefined;
  showWordmark?: boolean | undefined;
  onDark?: boolean | undefined;
}) {
  const sizing = showWordmark ? "h-10 w-auto" : "h-6 w-10";

  return (
    <span className={cn("inline-flex items-center", className)}>
      <img
        src={onDark ? logoWhite : logoDark}
        alt="HealNova Healthcare"
        className={cn("object-contain object-left", sizing)}
        width={394}
        height={110}
      />
    </span>
  );
}
